export default __webpack_public_path__ + "static/media/artwork-sample-1.4e596a36.png";